module.exports = __webpack_public_path__ + "static/img/u240.a382519.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u240.png
// module id = zwmQ
// module chunks = 1